import React, { useState, useEffect } from "react";
import AddProductForm from "../addproductcomponents/AddProductForm";
import axios from "axios";
import { baseurl } from "../../config/url";

const ManageProducts = () => {
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState({});
  const [expandedCategory, setExpandedCategory] = useState(null);
  const [productName, setProductName] = useState("");
  const [productDescription, setProductDescription] = useState("");
  const [productPrice, setProductPrice] = useState("");
  const [productSize, setProductSize] = useState("");
  const [maxquantity, setMaxquantity] = useState("");
  const [minquantity, setMinquantity] = useState("");
  const [stock, setStock] = useState(0);
  const [saleMode, setSaleMode] = useState("");
  const [image, setImage] = useState(null);
  const [specifications, setSpecifications] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedSubcategory, setSelectedSubcategory] = useState("");
  const [images, setImages] = useState([]);
  const [selectedCategoryName, setSelectedCategoryName] = useState("");
const [selectedSubcategoryName, setSelectedSubcategoryName] = useState("");
  const [deliveryPreference, setDeliveryPreference] = useState({
    duration: "",
    unit: "days", // Default unit
  });
  useEffect(() => {
    axios
      .get(`${baseurl}/api/category/get-all`)
      .then((response) => {
        setCategories(response.data);
      })
      .catch((error) => {
        console.error("Error fetching categories:", error);
      });
  }, []);

  const handleCategoryToggle = (category) => {
    setSelectedCategory(category?._id);
    setSelectedCategoryName(category?.name); // Store name instead of just ID
    // Toggle the expand/collapse state for the clicked category card
    if (expandedCategory && expandedCategory._id === category._id) {
      setExpandedCategory(null);
    } else {
      setExpandedCategory(category);

      // Fetch subcategories for the category if not already loaded
      if (!subcategories[category._id]) {
        axios
          .get(`${baseurl}/api/subcategory/category/${category._id}`)
          .then((response) => {
            setSubcategories((prevState) => ({
              ...prevState,
              [category._id]: response.data,
            }));
          })
          .catch((error) =>
            console.error("Error fetching subcategories:", error)
          );
      }
    }
  };

  const handleSubcategorySelect = (subcategory) => {
    setSelectedSubcategory(subcategory._id);
    setSelectedSubcategoryName(subcategory?.name); // Store name instead of just ID 

  };

  return (
    <div className="flex flex-col md:flex-row space-y-6 md:space-y-0 md:space-x-6 p-6">
      {/* Categories Section */}
      <div className="w-full md:w-1/4 p-4 rounded-lg shadow-md md:h-fit h-[450px] overflow-y-auto">
        <h3 className="text-xl font-semibold mb-4 text-gray-700">
          Select Category
        </h3>
        <div className="space-y-2">
          {categories.map((category) => (
            <div key={category._id}>
              <button
                onClick={() => handleCategoryToggle(category)}
                className={`w-full flex justify-between p-2 rounded-lg transition-colors duration-200 
            ${
              expandedCategory && expandedCategory._id === category._id
                ? "bg-blue-500 text-white"
                : "bg-gray-100 hover:bg-gray-300"
            }`}
              >
                {category.name}
                <span>
                  {expandedCategory && expandedCategory._id === category._id
                    ? "-"
                    : "+"}
                </span>
              </button>
              {/* Subcategories (only show when expanded) */}
              {expandedCategory &&
                expandedCategory._id === category._id &&
                subcategories[category._id] && (
                  <div className="ml-4 mt-2 space-y-1">
                    {subcategories[category._id].map((subcategory) => (
                      <button
                        key={subcategory._id}
                        onClick={() => handleSubcategorySelect(subcategory)}
                        className={`w-full text-left p-2 rounded-lg transition-colors duration-200 
                    ${
                      selectedSubcategory &&
                      selectedSubcategory === subcategory._id
                        ? "bg-green-500 text-white"
                        : "hover:bg-gray-300"
                    }`}
                      >
                        {subcategory.name}
                      </button>
                    ))}
                  </div>
                )}
            </div>
          ))}
        </div>
      </div>

      {/* Add Product Section */}
      <div className="w-full md:w-3/4 bg-white rounded-lg shadow-md">
        <AddProductForm
          setImages={setImages}
          images={images}
          productName={productName}
          setProductName={setProductName}
          productDescription={productDescription}
          setProductDescription={setProductDescription}
          productPrice={productPrice}
          setProductPrice={setProductPrice}
          productSize={productSize}
          setProductSize={setProductSize}
          maxquantity={maxquantity}
          setMaxquantity={setMaxquantity}
          minquantity={minquantity}
          setMinquantity={setMinquantity}
          stock={stock}
          setStock={setStock} // Pass setStock as a prop
          saleMode={saleMode}
          setSaleMode={setSaleMode}
          image={image}
          setImage={setImage}
          specifications={specifications}
          setSpecifications={setSpecifications}
          selectedCategory={selectedCategory}
          selectedSubcategory={selectedSubcategory}
          setDeliveryPreference={setDeliveryPreference}
          deliveryPreference={deliveryPreference}
          selectedCategoryName={selectedCategoryName} 
          selectedSubcategoryName={selectedSubcategoryName} 
        />
      </div>
    </div>
  );
};

export default ManageProducts;
